import { toast } from "sonner";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { PackagePlaceholder } from "./PackagePlaceholder";
import { ICONS } from "@/lib/icons";
import copy from "@/content/homepage-copy.json";

const { arrowRight: ArrowRight } = ICONS;

export const PackagesSection = () => {
  const p = copy.packages;

  const handleClick = (name) => {
    toast(p.unavailableCta, {
      description: `Strona pakietu „${name}" będzie dostępna wkrótce.`,
    });
  };

  return (
    <section id="pakiety" className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px]" data-testid="packages-section">
      <SectionHeading chapter="03 — PAKIETY" title={p.title} lead={p.lead} />
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {p.items.map((pkg, i) => (
          <Reveal key={pkg.id} delay={(i % 4) * 0.06}>
            <article
              className="group hover-glow flex h-full min-h-[420px] flex-col overflow-hidden rounded-card border border-brand-line bg-brand-surface hover:-translate-y-1"
              data-testid={`package-card-${pkg.id}`}
            >
              <PackagePlaceholder packageId={pkg.id} name={pkg.name} imageSrc={pkg.imageSrc || null} />
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-display text-[18px] font-semibold leading-snug text-brand-text">{pkg.name}</h3>
                <p className="mt-2 flex-1 text-[15px] leading-relaxed text-brand-sec">{pkg.benefit}</p>
                {/* promptCount i price = null → nie renderujemy pustych etykiet */}
                <button
                  type="button"
                  onClick={() => handleClick(pkg.name)}
                  data-testid={`package-cta-${pkg.id}`}
                  className="mt-5 inline-flex items-center justify-center gap-2 rounded-button border border-brand-line px-4 py-2.5 text-sm font-semibold text-brand-text transition-colors duration-200 hover:border-brand-accent hover:text-brand-accent"
                >
                  {p.cta}
                  <ArrowRight size={16} strokeWidth={2} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      {/* przejście do konfiguratora zestawu */}
      <Reveal delay={0.1}>
        <div
          className="glow-strong mt-8 flex flex-col items-center justify-between gap-4 rounded-panel border border-brand-accent/30 bg-brand-elevated p-6 text-center sm:flex-row sm:text-left md:p-8"
          data-testid="packages-bridge"
        >
          <p className="text-[16px] leading-relaxed text-brand-sec">{p.bridgeText}</p>
          <a
            href="/rejestracja"
            data-testid="packages-bridge-cta"
            className="cta-glow inline-flex shrink-0 items-center justify-center gap-2 rounded-button bg-brand-accent px-7 py-4 text-base font-semibold text-brand-on transition-transform duration-200 hover:-translate-y-0.5"
          >
            {p.bridgeCta}
            <ArrowRight size={18} strokeWidth={2} aria-hidden="true" />
          </a>
        </div>
      </Reveal>
    </section>
  );
};
